import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-generic-toggle',
  templateUrl: './generic-toggle.component.html',
  styleUrls: ['./generic-toggle.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: GenericToggleComponent
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: GenericToggleComponent
    }
  ]

})
export class GenericToggleComponent implements OnInit {

  @Input() value: boolean;
  @Output() onSave = new EventEmitter();
  @Output("sendData") sendData: EventEmitter<any> = new EventEmitter();
       
  touched = false;
  disabled = false;
  
  ngOnInit() {
  }
  
  onChange = (value) => {};
  onTouched = () => {};

  onToggle() {
    this.markAsTouched();
    if (!this.disabled) {
      this.onChange(this.value);
      this.sendData.emit(this.value);
    }
   }
  
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }
  
  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }
  
  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  writeValue(value: boolean) {
    this.value = value;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value <= 0) {
      return {
        mustBe: {
          value
        }
      };
    }
  }

  
}



// WEBPACK FOOTER //
// ./src/app/element/generic-toggle/generic-toggle.component.ts